import { useState, useEffect } from 'react';
import { pageContentAPI } from '../services/api';

/** Fetch CMS content blocks for a page */
export default function usePageContent(page, language) {
  const [blocks, setBlocks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    pageContentAPI
      .getAll({ page, language, limit: 20 })
      .then((res) => setBlocks(res.data.data))
      .catch(() => setBlocks([]))
      .finally(() => setLoading(false));
  }, [page, language]);

  return { blocks, loading };
}
